import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.less';

export default function RedPacket({packet}) {
    let {wish, totalamount, totalcnt, type} = packet;
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.total}>¥{totalamount}</div>
                <div className={styles.titleContent}>
                    <div className={styles.title}>{wish}</div>
                    <div className={styles.subTitle}>限定{totalcnt}个领取人数</div>
                </div>
            </div>
            <div className={styles.type}>
                {type === 1 && '普通红包'}
                {type === 2 && '拼手气群红包'}
                {type === 3 && '激励群红包'}
            </div>
        </div>
    );
}

RedPacket.propTypes = {
    packet: PropTypes.object,
};
